<script>import { onDestroy, SvelteComponent } from "svelte";
import { customFade } from "../FloatingUI/transitions";
import { get_current_component } from "svelte/internal";
import { twJoin } from "tailwind-merge";
export let parentElementId;
export let offsetX = 0;
export let offsetY = 0;
export let autoDismiss = void 0;
export let props;
export let component;
export let id;
export let store;
export let shadow = true;
let element;
let parentElement;
let stopObserver;
let listener;
let top;
let left;
let intersectionObserver;
let timer = autoDismiss ? setTimeout(() => {
  $store = null;
}, autoDismiss) : null;
const thisComponent = get_current_component();
let internal_timer;
$:
  isActive = $store === id;
$: {
  if (!isActive) {
    internal_timer = setTimeout(() => {
      thisComponent.$destroy();
    }, 1e3);
  } else {
    clearTimeout(internal_timer);
  }
}
function handleRerender() {
  let parentOffsetX = document.getElementById(parentElementId)?.getBoundingClientRect()?.left;
  let parentOffsetY = document.getElementById(parentElementId)?.getBoundingClientRect()?.bottom;
  let parentWidth = document.getElementById(parentElementId)?.offsetWidth;
  let adjustedOffsetY = parentOffsetY + offsetY;
  let adjustedOffsetX = parentOffsetX + offsetX - element?.offsetWidth + parentWidth;
  return {
    adjustedOffsetX,
    adjustedOffsetY
  };
}
function renderComponentOnScreen() {
  let windowHeight = window.innerHeight;
  let { adjustedOffsetX, adjustedOffsetY } = handleRerender();
  if (element && element.getBoundingClientRect().bottom > windowHeight || element && element.offsetHeight + adjustedOffsetY > windowHeight) {
    adjustedOffsetY = adjustedOffsetY - (element.offsetHeight + parentElement.offsetHeight);
  }
  return {
    adjustedOffsetX,
    adjustedOffsetY
  };
}
function observeElementMovement(element2) {
  let lastRect = element2.getBoundingClientRect();
  function checkForChanges() {
    const newRect = element2.getBoundingClientRect();
    if (lastRect.top !== newRect.top || lastRect.left !== newRect.left || lastRect.width !== newRect.width || lastRect.height !== newRect.height) {
      lastRect = newRect;
      const event = new CustomEvent("elementMoved", {
        detail: { rect: newRect }
      });
      element2.dispatchEvent(event);
    }
  }
  window.addEventListener("scroll", checkForChanges, true);
  intersectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        $store = null;
      }
    });
  });
  intersectionObserver.observe(element2);
  const resizeObserver = new ResizeObserver(checkForChanges);
  resizeObserver.observe(element2);
  const mutationObserver = new MutationObserver(checkForChanges);
  mutationObserver.observe(document.body, { attributes: true, childList: true, subtree: true });
  return () => {
    resizeObserver.disconnect();
    mutationObserver.disconnect();
    intersectionObserver.unobserve(element2);
  };
}
function handleElementMoved() {
  left = renderComponentOnScreen().adjustedOffsetX;
  top = renderComponentOnScreen().adjustedOffsetY;
}
function resetTimer() {
  if (autoDismiss) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      $store = null;
    }, autoDismiss);
  }
}
$: {
  if (isActive) {
    resetTimer();
    parentElement = document.getElementById(parentElementId);
    stopObserver = observeElementMovement(parentElement);
    listener = parentElement.addEventListener("elementMoved", handleElementMoved);
  } else {
    if (stopObserver) {
      stopObserver();
    }
  }
}
onDestroy(() => {
  if (stopObserver) {
    stopObserver();
  }
  if (element && listener) {
    parentElement.removeEventListener("elementMoved", handleElementMoved);
  }
  if (timer) {
    clearTimeout(timer);
  }
});
</script>

{#if isActive}
	<div
		transition:customFade={{ duration: 150, beforeRender: renderComponentOnScreen }}
		bind:this={element}
		class={twJoin("absolute z-[9000]", shadow && "shadow-lg")}
		style={`left: ${left ?? 0}px; top: ${top ?? 0}px;`}
	>
		<svelte:component this={component} id={id} {...props} />
	</div>
{/if}
